import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom
} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withNoXsrfProtection
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  InMemoryScrollingFeature,
  withInMemoryScrolling,
  InMemoryScrollingOptions,
  provideRouter,
  Router
} from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import * as Sentry from '@sentry/angular';
import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service } from 'ng-recaptcha';

import { environment } from 'environments/environment';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { EnvironmentProtectionInterceptor } from './shared/interceptors/enviroment-protection.interceptor';
import { routes } from './app.routes';
import { chatReducer } from './store/chat/chat.reducer';
import { ChatEffects } from './store/chat/chat.effects';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled'
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(HttpClientModule),
    provideHttpClient(withNoXsrfProtection()),
    provideAnimations(),
    provideRouter(routes, inMemoryScrollingFeature),
    provideStore({
      chat: chatReducer
    }),
    provideEffects([ChatEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production
    }),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey
    },
    ReCaptchaV3Service,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EnvironmentProtectionInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    }
  ]
};
